export const useMapStyle = (mode: string) => {
  const client = process.env.REACT_APP_CLIENT || "core";

  if (client === 'gravity') {
    if (mode === 'dark') {
      return "mapbox://styles/mpilarczykstarcount/cm0qr47xx00ns01qkdt8ud9se";
    } else {
      return "mapbox://styles/mpilarczykstarcount/cm0tlhqzz00rk01o30mhhh3sp";
    }
  } else if (client === 'miroma') {
    if (mode === 'dark') {
      return "mapbox://styles/mpilarczykstarcount/cm0qr47xx00ns01qkdt8ud9se";
    } else {
      return "mapbox://styles/mpilarczykstarcount/cm0tlhqzz00rk01o30mhhh3sp";
    }
  } else {
    if (mode === "dark") {
      return "mapbox://styles/mpilarczykstarcount/clkgquj99007501qpdl0ebfr5";
    } else {
      return "mapbox://styles/mpilarczykstarcount/clzjoxepg004a01qx6ytt26kd";
    }
  }
};

export const useMapHeight = (extra: boolean = false) => {
  const client = process.env.REACT_APP_CLIENT || "core";

  if (client === 'gravity') {
    return extra ? 607 : 440
  } else if (client === 'miroma') {
    return extra ? 517 : 350
  } else {
    return extra ? 517 : 350;
  }
};
